import React, { Component } from "react";
import { Icon, Tab, Menu } from "semantic-ui-react";
import { pageViewTabpanes, getFbViewChart } from "./utils";
// import { isFirefox, isChrome, isSafari } from "react-device-detect";
import moment from "moment";
import html2canvas from "html2canvas";
import { ReactComponent as MoreOptions } from "../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../Dashboard/Charts/ChartsOptionsSidebar/CustomCheckBox";
import FBIntervalSelector from "./FBIntervalSelector";
import TabSelector from "./TabSelector";
import ChartName from "../Dashboard/Charts/ChartName";
import FBPageSelector from "./FBPageSelector";
import DeleteWidget from "../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../assets/svg/settings.svg";
import { ReactComponent as ArrowIcon } from "../../../assets/svg/chevron.svg";
import DimmerComponent from "../Dashboard/DimmerComponent";
import { downloadCanvasWithTitle, downloadCSVData } from "../Dashboard/Charts/utils";
import { ChartFilterIcon } from "../Dashboard/Charts/ChartFilterOptions";
import { ReactComponent as MiniMize } from "../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../Dashboard/Charts/DownloadChart";
class PageViewOvertime extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.chart = React.createRef();
    }

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    { name: "PNG", downloadFn: this.downloadPNG, showLoader: true },
                ]}
            />
        );
    }

    downloadPNG = (cb) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        if (this.chart?.current)
            return html2canvas(this.chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, this.props.widget?.name || "Page Views");
                },
            );
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        let data = this.props.data;

        let columns = [];
        let fields = [];

        if (this.props.activeIndex === 0) {
            columns = [["Time"], ["Total Views"]];
            fields = ["totalPageView"];
            data.totalPageView.data.map((datArray) => {
                columns[0].push(datArray[0]);
            });
        } else if (this.props.activeIndex === 1) {
            columns = [["Time"], ["Home"], ["Posts"], ["Reviews"], ["Videos"]];
            fields = ["home", "posts", "reviews", "videos"];
            data.home.data.map((datArray) => {
                columns[0].push(datArray[0]);
            });
        } else {
            columns = [["Time"], ["Computers"], ["Mobiles"]];
            fields = ["computers", "mobiles"];
            if (data.computers.data.length > data.mobiles.data.length) {
                data.computers.data.map((datArray) => {
                    columns[0].push(datArray[0]);
                });
            } else
                data.mobiles.data.map((datArray) => {
                    columns[0].push(datArray[0]);
                });
        }

        let formatString = "YYYY-MM-DD HH:mm";

        fields.map((field, index) => {
            data[field].data?.map((datArray) => {
                if (datArray) columns[index + 1].push(datArray[1]);
            });
        });

        columns[0] = columns[0].map((d) => (d === "Time" ? "Time" : moment(d).format(formatString)));

        let csvFmt = columns[0].map((col, i) => columns.map((row) => row[i]));

        downloadCSVData(csvFmt, this.props.widget?.name || "Page Views");
    };

    getPanes() {
        return pageViewTabpanes.map((pane) => {
            return {
                menuItem: (
                    <Menu.Item id={"idx" + pane.menuItem} key={pane.menuItem}>
                        {pane.menuItem}
                    </Menu.Item>
                ),
                render: () => <Tab.Pane>{this.getCharts(pane.chartsList, pane.menuItem)}</Tab.Pane>,
            };
        });
    }

    increment = () => {
        if (this.props.fbSelectedPageIds.length === 1) return;
        let index;
        this.props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === this.props.selectedFbPage?.value) index = ind;
        });
        if (index === this.props.fbSelectedPageIds.length - 1) this.props.setSelectedFbPage(this.props.fbSelectedPageIds[0]);
        else this.props.setSelectedFbPage(this.props.fbSelectedPageIds[index + 1]);
    };

    decrement = () => {
        if (this.props.fbSelectedPageIds.length === 1) return;
        let index;
        this.props.fbSelectedPageIds.map((value, ind) => {
            if (value.id === this.props.selectedFbPage?.value) index = ind;
        });
        if (index === 0) this.props.setSelectedFbPage(this.props.fbSelectedPageIds[this.props.fbSelectedPageIds.length - 1]);
        else this.props.setSelectedFbPage(this.props.fbSelectedPageIds[index - 1]);
    };

    getCharts(chartsList, pane) {
        return chartsList.map((chart) => {
            let Component = getFbViewChart(chart).component;
            return (
                <Component
                    key={chart}
                    showLegend={this.props.showLegend}
                    showGridLines={this.props.showGridLines}
                    data={this.props.data}
                    graph_type={this.props.graph_type}
                    resizedCount={this.props.resizedCount}
                    isFBPage={this.props.isFBPage}
                    widgetContainerRef={this.props.isFBPage ? this.chart : this.props.widgetContainerRef}
                    pageStatus={this.props.pageStatus}
                />
            );
        });
    }

    // getChart() {
    //     let chart = pageViewTabpanes[this.props.activeIndex].chartsList[0];
    //     let Component = getFbViewChart(chart).component;
    //     return (
    //         // <section key={chart} className={`unified-chart ${chart}`} ref={this.chart}>
    //         <div className="dashboard-chart skiptranslate" ref={this.chart}>
    //             <Component
    //                 showLegend={this.props.showLegend}
    //                 showGridLines={this.props.showGridLines}
    //                 data={this.props.data}
    //                 graph_type={this.props.graph_type}
    //                 resizedCount={this.props.resizedCount}
    //             />
    //         </div>
    //         // </section>
    //     );
    // }

    isNoDataKey = (key) => {
        let x = this.props.data[key] ? (this.props.data[key]?.data && this.props.data[key]?.data.length > 0 ? false : true) : true;
        return x;
    };

    isNoData = () => {
        if (this.props.pageStatus) return true;

        if (this.props.data?.totalPageView?.data?.length > 0 || this.props.data?.computers?.data?.length > 0 || this.props.data?.mobiles?.data?.length)
            return false;

        if (this.props.activeIndex === 1) {
            return this.props.data
                ? this.isNoDataKey("home") &&
                      this.isNoDataKey("about") &&
                      this.isNoDataKey("posts") &&
                      this.isNoDataKey("reviews") &&
                      this.isNoDataKey("videos") &&
                      this.isNoDataKey("services")
                : true;
        } else return true;
    };

    render() {
        const chartOptions = [
            { label: "Total Views", value: 0 },
            { label: "By Section", value: 1 },
            { label: "By Device", value: 2 },
        ];

        const elements = (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        isFacebook
                        name={this.props.widget?.name || "Page Views"}
                        info="The number of times a page's profile has been viewed by logged in and logged out people."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.isNoData() && (
                            <div className="chart-type">
                                <span onClick={() => this.props.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                                <span onClick={() => this.props.changeGraphType("line")} className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="line chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isFBPage &&
                            !this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && !this.isNoData() && this.renderDownloadButton(this.isNoData())}
                        {
                            <>
                                {(this.props.isPublic && this.isNoData()) || this.props.isFBPage ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }

                        {this.props.isPublic && this.isNoData() ? null : (
                            <MoreOptions
                                className={this.isNoData() && this.props.isFBPage ? "pointer-disabled" : "more-options"}
                                onClick={(e) => this.props.changeShowMoreOptions(e)}
                            />
                        )}
                    </div>
                    {this.props.showMoreOptions && (
                        <ChartOptionsSidebar
                            data-html2canvas-ignore="true"
                            showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                            changeShowMoreOptions={this.props.changeShowMoreOptions}>
                            {/* {!this.props.isFBPage && this.props.selectedFbPage && (
                                <FBPageSelector
                                    selectedFbPage={this.props.selectedFbPage}
                                    setSelectedFbPage={this.props.setSelectedFbPage}
                                    fbSelectedPageIds={this.props.fbSelectedPageIds}
                                />
                            )} */}
                            {/* <TabSelector options={chartOptions} value={this.props.activeIndex} onChange={(e) => this.props.setActivePageViewTab(e)} /> */}
                            {!this.isNoData() && (
                                <>
                                    <CustomCheckBox checked={this.props.showUniqueLines} onClick={this.props.changeShowUniqueLine} label="Show Unique" />
                                    <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />
                                    <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />
                                    <FBIntervalSelector
                                        aggs_val={this.props.aggs_val}
                                        appliedFilter={this.props.appliedFilter}
                                        handleIntervalChange={this.props.handleIntervalChange}
                                    />
                                </>
                            )}
                            {!this.props.isFBPage &&
                                !this.props.isPublic &&
                                !this.props.isStandardDashboard &&
                                !this.props.isResearchDashboard &&
                                this.props.dashboardPageType !== "temporaryInsights" &&
                                this.props.dashboardPageType !== "temporary" && (
                                    <>
                                        <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                            <span>Chart Configuration</span>
                                            <Settings />
                                        </div>
                                        <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                            <span>Clone Chart</span>
                                            <CloneIcon />
                                        </div>
                                        <DeleteWidget onClick={this.props.deleteWidget} />
                                    </>
                                )}
                        </ChartOptionsSidebar>
                    )}
                </div>

                <div className="dashboard-chart dashboard-chart-slider skiptranslate" ref={this.chart}>
                    {!this.props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-left ${this.props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}
                            onClick={this.decrement}>
                            <ArrowIcon />
                        </div>
                    )}
                    <div className="chart-area">
                        {!this.props.isFBPage && this.props.selectedFbPage && (
                            <FBPageSelector
                                selectedFbPage={this.props.selectedFbPage}
                                setSelectedFbPage={this.props.setSelectedFbPage}
                                fbSelectedPageIds={this.props.fbSelectedPageIds}
                                widgetContainerRef={this.props.widgetContainerRef}
                            />
                        )}
                        <Tab
                            className="page_view_tabs views-tabs"
                            onTabChange={(e, data) => {
                                this.props.setActivePageViewTab(data.activeIndex);
                            }}
                            panes={this.getPanes()}
                            activeIndex={this.props.activeIndex}
                        />
                        {(!this.props.selectedFbPage || this.props.loading) && <DimmerComponent />}
                    </div>
                    {!this.props.isFBPage && (
                        <div
                            data-html2canvas-ignore="true"
                            className={`chart-slider chart-slider-right ${this.props.fbSelectedPageIds.length === 1 ? "disabled" : ""}`}
                            onClick={this.increment}>
                            <ArrowIcon />
                        </div>
                    )}
                </div>
            </>
        );

        return this.props.isFBPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
    }
}

export default PageViewOvertime;
